import { ImageIcon } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const HIGHLIGHTS = [
  { k: "20+", v: "év tapasztalat" },
  { k: "AT", v: "osztrák alapanyagok" },
  { k: "HU · SK", v: "működési terület" },
];

export default function About() {
  return (
    <section id="rolunk" data-testid="about-section" className="scroll-mt-24 bg-slate-50 py-16 sm:py-20 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 px-5 md:px-10 items-center">
        <Reveal>
          <div className="relative">
            <div
              data-testid="about-image-placeholder"
              className="relative flex items-center justify-center overflow-hidden rounded-[2rem] border border-slate-200 bg-gradient-to-br from-[#0E5A75] to-[#0B4A60] shadow-2xl shadow-[#0E5A75]/15 aspect-[4/5] sm:aspect-square"
            >
              <div className="absolute inset-0 noise-overlay opacity-[0.12]" />
              <div className="pointer-events-none absolute -top-16 -right-16 h-56 w-56 rounded-full bg-emerald-400/20 blur-3xl" />
              <div className="relative flex flex-col items-center text-center px-8">
                <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10 backdrop-blur">
                  <ImageIcon className="h-8 w-8 text-emerald-400" />
                </span>
                <span className="mt-6 text-xs font-semibold uppercase tracking-[0.24em] text-emerald-400">Fotó</span>
                <span className="mt-3 text-3xl sm:text-4xl font-extrabold text-white">Hamarosan érkezik</span>
                <span className="mt-3 text-sm text-slate-300 max-w-[240px]">Csapatunk és munkáink fotói hamarosan felkerülnek ide.</span>
              </div>
            </div>
            <div className="absolute -right-3 -bottom-3 sm:-right-6 sm:-bottom-6 rounded-2xl bg-emerald-400 px-6 py-5 shadow-xl">
              <div className="text-2xl font-extrabold text-[#0E5A75]">Tetőklinika</div>
              <div className="text-sm font-medium text-[#0E5A75]/80">GRUDA-BAU Kft.</div>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal><Overline>Rólunk</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0E5A75] text-balance">
              Tetőklinika – szakértelem a tető minden rétegében
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              A Tetőklinika több mint 20 éves szakmai tapasztalattal vállal tetőfedési, tetőjavítási
              és bádogos munkákat. Cserép- és palatetők kivitelezésével, valamint régi tetők bontás
              nélküli felújításával is foglalkozunk.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-4 text-base text-slate-600 leading-relaxed">
              Felkészült szakemberekkel, minőségi osztrák alapanyagokkal és precíz kivitelezéssel
              dolgozunk. Szolgáltatásaink Nyugat-Magyarországon, a Dunántúl több megyéjében, Pest
              megyében, valamint Szlovákia területén is elérhetők. Célunk, hogy minden ingatlanhoz a
              megrendelő igényeinek megfelelő, hosszú távon is megbízható tetőmegoldást biztosítsunk.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-8 grid grid-cols-3 gap-4 border-t border-slate-200 pt-8">
              {HIGHLIGHTS.map((h) => (
                <div key={h.v}>
                  <div className="text-2xl sm:text-3xl font-extrabold text-emerald-600">{h.k}</div>
                  <div className="mt-1 text-xs sm:text-sm text-slate-500 leading-snug">{h.v}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
